import React, { useState, useEffect } from 'react'
import './Countdown.css'

const calculateCountdown = (targetDate) => {
    const now = new Date();

    const start = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    let current = new Date(start);

    const end = new Date(
        targetDate.getFullYear(),
        targetDate.getMonth(),
        targetDate.getDate()
    );

    let months = 0;

    // Count full months
    while (true) {
        const next = new Date(current);
        next.setMonth(next.getMonth() + 1);

        if (next <= end) {
            months++;
            current = next;
        } else {
            break;
        }
    }

    // Remaining days
    const diffMs = end - current;
    const totalDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

    const weeks = Math.floor(totalDays / 7);
    const days = totalDays % 7;

    return { months, weeks, days };
};

const Countdown = ({ colourScheme, weddingDate }) => {

    const [timeLeft, setTimeLeft] = useState({
        months: 0,
        weeks: 0,
        days: 0
    });

    useEffect(() => {
        const updateCountdown = () => {
            const result = calculateCountdown(new Date(weddingDate));
            setTimeLeft(result);
        };

        updateCountdown(); 

        const interval = setInterval(updateCountdown, 1000 * 60 * 60); // update hourly

        return () => clearInterval(interval);
    }, [weddingDate]);

    const { months, weeks, days } = timeLeft;

    return (
        <div className={`countdown-container ${colourScheme}-countdown`}>
            {/* Confetti overlay */}
            <div
                className="confetti-overlay"
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundImage: `url(${require(`../../Assets/custom-site/${colourScheme}/confetti-countdown.png`)})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    zIndex: 0
                }}
            ></div>

            {/* Content */}
            <div style={{ position: 'relative', zIndex: 1 }}>
                <h2 className="countdown-header">Let the countdown begin</h2>

                <div className="countdown-display">
                    <div className="countdown-item">
                        <p className="countdown-number">{months}</p>
                        <p className="countdown-label">MONTHS</p>
                    </div>

                    <div className="countdown-divider"></div>

                    <div className="countdown-item">
                        <p className="countdown-number">{weeks}</p>
                        <p className="countdown-label">WEEKS</p>
                    </div>

                    <div className="countdown-divider"></div>

                    <div className="countdown-item">
                        <p className="countdown-number">{days}</p>
                        <p className="countdown-label">DAYS</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Countdown